<template>
  <v-card
    class="rounded-lg"
  >
    <slot name="header" />

    <v-card-text :class="contentClass">
      <apexchart
        id="radar-chart"
        type="radar"
        class="w-100"
        :height="height"
        :width="width"
        :options="chartOptions"
        :series="series"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { ApexChartsLocale } from '@/data/models/ApexchartsLocale'
import i18n from '@/plugins/i18n'

export default {
  name: 'RadarChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    series: {
      type: Array,
      required: true
    },
    hideLabels: {
      type: Boolean,
      default: false
    },
    colors: {
      type: Array,
      default: () => ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0']
    },
    height: {
      type: String,
      default: '350'
    },
    width: {
      type: String,
      default: '100%'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: null
    },
    xaxis: {
      type: Object,
      default: () => ({
        labels: {
          show: true
        }
      })
    },
    yaxis: {
      type: Object,
      default: () => ({})
    },
    tooltip: {
      type: Object,
      default: () => ({
        enabled: true
      })
    },
    fill: {
      type: Object,
      default: () => ({
        opacity: 0.5
      })
    }
  },
  computed: {
    colorss() {
      return this.$vuetify.theme.secondary
    },
    chartOptions() {
      return {
        colors: this.colors,
        chart: {
          height: this.height,
          toolbar: {
            show: false
          },
          type: 'radar',
          locales: ApexChartsLocale,
          defaultLocale: i18n.locale
        },
        xaxis: this.xaxis,
        yaxis: this.yaxis,
        fill: this.fill,
        tooltip: this.tooltip
      }
    }
  }
}
</script>
